import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRotinasOutletContext } from 'pages/Rotinas.context'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { rotinas } from 'service/api'
import { toast } from 'sonner'

/**
 * Confirma a exclusão e, se a rotina está ativa, oferece pausá-la no lugar —
 * pausar preserva a configuração para reativar depois.
 */
export default function ExcluirRotina() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { data } = useRotinasOutletContext()
    const rotina = data?.find(it => it.id === Number(id))
    const [isPausando, setIsPausando] = useState(false)
    const { mutateAsync, isLoading } = rotinas.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!rotina) return null

    const excluir = () =>
        mutateAsync(rotina.id, {
            onSuccess: () => {
                toast.success('Rotina excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    const pausar = () => {
        setIsPausando(true)
        rotinas
            .alternarAtiva(rotina.id, false)
            .then(() => {
                toast.success('Rotina pausada')
                rotinas.invalidateQueries()
                navigate(-1)
            })
            .catch(err => toast.error(err.message))
            .finally(() => setIsPausando(false))
    }

    return (
        <Dialog.Root
            width="fit"
            shouldTransformarValores={false}
            loading={isLoading || isPausando}
            onSubmit={excluir}
            open={hasPermission(['delete', 'Rotinas'])}
        >
            <Dialog.Title wrap action="Excluir rotina">
                {rotina.nome}
            </Dialog.Title>
            <Dialog.Content>
                <p>
                    A rotina deixa de ser executada. Se puder precisar dela de
                    novo, pause em vez de excluir.
                </p>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                {rotina.ativa && (
                    <Dialog.Actions.SecondaryButton
                        variant="outlined"
                        onClick={pausar}
                    >
                        Pausar
                    </Dialog.Actions.SecondaryButton>
                )}
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
